import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getReqTags = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/req-tags`, data);
        return await response.data;
    } catch (error) {
        console.log("getReqTags - error", error)
        return handleApiError(error)
    }
}

export const getReqTagById = async (reqTagId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/req-tags/${reqTagId}`);
        return await response.data;
    } catch (error) {
        console.log("getReqTagById - error", error)
        return handleApiError(error)
    }
}